import { useCallback, useMemo, useRef, useState } from 'react';
function useFieldValidation(validatedFields, getFieldError, getFieldLabel) {
    const [touched, setTouched] = useState({});
    // Ref so validateAll always uses the latest getFieldError without needing it as a dep
    const getFieldErrorRef = useRef(getFieldError);
    getFieldErrorRef.current = getFieldError;
    const markTouched = useCallback((name) => {
        setTouched((prev) => (Object.assign(Object.assign({}, prev), { [name]: true })));
    }, []);
    const errors = useMemo(() => validatedFields.reduce((acc, field) => (Object.assign(Object.assign({}, acc), { [field]: touched[field] ? getFieldError(field) : null })), {}), [validatedFields, touched, getFieldError]);
    const isValid = useMemo(() => validatedFields.every((field) => getFieldError(field) === null), [validatedFields, getFieldError]);
    const pendingFields = useMemo(() => validatedFields
        .filter((field) => getFieldError(field) !== null)
        .map((field) => getFieldLabel(field)), [validatedFields, getFieldError, getFieldLabel]);
    const validateAll = useCallback(() => {
        setTouched(validatedFields.reduce((acc, f) => (Object.assign(Object.assign({}, acc), { [f]: true })), {}));
        return validatedFields.every((field) => getFieldErrorRef.current(field) === null);
    }, [validatedFields]);
    return { errors, isValid, pendingFields, markTouched, validateAll };
}
export default useFieldValidation;
